const Lines = ({ label, value, onChange, testId }) => (
  <div>
    <label className="label">{label} (one per line)</label>
    <textarea className="field min-h-[150px]" value={(value || []).join("\n")} onChange={(e) => onChange(e.target.value.split("\n"))} data-testid={testId} />
  </div>
);

export const ListsEditor = ({ s, set }) => (
  <section className="panel p-6">
    <h2 className="red-title mb-4 text-xl">Forms & Lists</h2>
    <div className="grid gap-4 md:grid-cols-4">
      <Lines label="Order item types" value={s.item_types} onChange={(v) => set("item_types", v)} testId="admin-settings-item-types" />
      <Lines label="Print placements" value={s.placements} onChange={(v) => set("placements", v)} testId="admin-settings-placements" />
      <Lines label="Quote services" value={s.quote_services} onChange={(v) => set("quote_services", v)} testId="admin-settings-quote-services" />
      <Lines label="Design Studio fonts (Google Fonts names)" value={s.design_fonts} onChange={(v) => set("design_fonts", v)} testId="admin-settings-design-fonts" />
    </div>
    <p className="label mt-6">"How it works" steps (Home + Order page)</p>
    <div className="grid gap-3 md:grid-cols-3">
      {(s.home_steps || []).map((st, i) => (
        <div key={i} className="space-y-2" data-testid={`admin-settings-step-${i}`}>
          <input className="field" value={st.title} onChange={(e) => set("home_steps", s.home_steps.map((x, n) => (n === i ? { ...x, title: e.target.value } : x)))} data-testid={`admin-settings-step-title-${i}`} />
          <textarea className="field min-h-[80px]" value={st.text} onChange={(e) => set("home_steps", s.home_steps.map((x, n) => (n === i ? { ...x, text: e.target.value } : x)))} data-testid={`admin-settings-step-text-${i}`} />
        </div>
      ))}
    </div>
  </section>
);
